module.exports = __webpack_public_path__ + "05_mustache_brown.a4ad92b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/05_mustache_brown.png
// module id = PGXp
// module chunks = 0